const getters = {
  userInfo: state => state.user.userInfo,
  isLogin: state => state.user.isLogin,
  userBranchInfo: state => state.user.userBranchInfo,
  isBranchLogin: state => state.user.isBranchLogin,
  isProductInfo: state => state.user.isProductInfo,
  resourcesId: state => state.resources.resourcesId,
  searchResultContext: state => state.resources.searchResultContext,
  searchResultText: state => state.resources.searchResultText,
  existSearchFlag: state => state.resources.existSearchFlag,
  searchType: state => state.resources.searchType,
  searchKeyword: state => state.resources.searchKeyword,
  checkedCatalogIndex: state => state.resources.checkedCatalogIndex,
  resourcesTypes: state => state.resources.resourcesTypes,
  isOrganised: state => state.resources.isOrganised,
  isCourse: state => state.resources.isCourse,
  sso_web_url: state => state.resources.sso_web_url,
  catalogObj: state => state.catalog.catalogObj,
  catalogNamess: state => state.catalog.catalogNamess,
  catalogSnss: state => state.catalog.catalogSnss,
  pdfCurrentCata: state => state.catalog.pdfCurrentCata,
  // slaveCabpid: state => state.catalog.slaveCabpid,
  currentCourseCatalog: state => state.catalog.currentCourseCatalog,
  firstItem: state => state.catalog.firstItem,
  courseHandleNodes: state => state.catalog.courseHandleNodes,
  imgList: state => state.catalog.imgList,
  caseCatalogHandleNodes: state => state.catalog.caseCatalogHandleNodes,
  courseCatalogNode: state => state.catalog.courseCatalogNode,
  page: state => state.resources.page,
  pageSize: state => state.resources.pageSize,
  total: state => state.resources.total,
  host: state => state.user.host,
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getter/getter.js